import React from 'react';
import { Link, } from "react-router-dom"

import icon_arrow_r from '../assets/img/common/icon_arrow_r.svg';

export interface BreadcrumbItem {
    'label': string,
    'path': string
}
type BreadcrumbProps = {
    itemLists?: BreadcrumbItem[];
}
/**
 * パンくずリストを表示する部品
 * @param params パンくず表示するラベルとリンクの配列
 * 例）TOP > 検索 > 結果 と表示する場合
 * 　[
 * 　　{'label': 'TOP', 'path': '/'},
 * 　　{'label': '検索', 'path': '/search'},
 * 　　{'label': '結果', 'path': '/search/result'}
 * 　]
 */
const Breadcrumb: React.FC<BreadcrumbProps> = (params) => {

    const { itemLists = [] } = params;
    
    // 先頭リスト
    const preBreadcrumbLink = (item:BreadcrumbItem) => (
        <li className="l-breadcrumb__item"><a href={item.path} className="l-breadcrumb__link">{item.label}</a></li>
    )
    // 末尾リスト
    const latestBreadcrumbLink = (item:BreadcrumbItem) => (
        <li className="l-breadcrumb__item"><span className="l-breadcrumb__separator"><svg width={6} height={10} aria-label="次の階層へのリンク"><use href={`${icon_arrow_r}#iconArrowR`} /></svg></span><span className="l-breadcrumb__link" aria-current="page">{item.label}</span></li>
    )
    // 道中リスト
    const breadcrumbLink = (item:BreadcrumbItem) => (
        <li className="l-breadcrumb__item"><span className="l-breadcrumb__separator"><svg width={6} height={10} aria-label="次の階層へのリンク"><use href={`${icon_arrow_r}#iconArrowR`} /></svg></span><Link to={item.path} className="l-breadcrumb__link">{item.label}</Link></li>
    )

    return (
        <nav aria-label="パンくずリスト" className="l-breadcrumb">
            <ol className="l-breadcrumb__list">
                {itemLists.map((item:BreadcrumbItem, index: number) => {
                    if (index == 0) {   // 先頭
                        return preBreadcrumbLink(item);
                    } else if (index == (itemLists.length - 1)) {   // 末尾
                        return latestBreadcrumbLink(item);
                    } else {    // 中間
                        return breadcrumbLink(item);
                    }
                })
                }
            </ol>
        </nav>
    );
};
export default Breadcrumb;